import { Location } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { SearchObserver } from "../../../observers/search.observer";
import { ProductService } from "../../../services/product.service";
import { ProductsComponent } from "../products/products.component";
import { Product } from "../../../models/product.model";
import { ActivatedRoute, Router } from "@angular/router";
import { BookLanguageObserver } from "../../../observers/book_language.observer";
import Timeout = NodeJS.Timeout;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnChanges {

  @ViewChild('searchBar') searchBar: ElementRef<any>
  @ViewChild('productComponent') productComponent: ProductsComponent

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = undefined;
    }
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      this.performSearch()
    } else if (event.code === 'Escape') {
      this.searchObserver.hideSearchBar()
    } else {
      this.searchTimeout = setTimeout(() => {
        this.performSearch()
      }, 500)
    }
  }

  isVisible = false
  page = 1
  products: Product[] = []
  searchTerm: string
  searchTimeout: Timeout | undefined;

  constructor(
    private bookLanguageObserver: BookLanguageObserver,
    private searchObserver: SearchObserver,
    private productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    this.bookLanguageObserver.bookLanguageObserver.subscribe(
      () => {
        this.performSearch()
      }
    )

    this.route.url.subscribe(
      url => {
        this.route.queryParams.subscribe(
          (params) => {
            if (params['page']) {
              this.page = +params['page']
            }

            if (params['q']) {
              this.searchTerm = params['q']
              this.performSearch()
            }
          }
        )
      }
    )
  }


  ngOnInit(): void {
    this.searchObserver.searchVisibilityObserver.subscribe(
      (visible) => {
        this.isVisible = visible
        if (this.isVisible) {
          setTimeout(
            () => {
              this.searchBar.nativeElement.focus()
            }, 300
          )
        }
      }
    )
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  handlePageChange(page: number) {
    this.page = page
    this.performSearch()
  }

  handleProductSelected(product: Product) {
    this.searchObserver.hideSearchBar()
    this.router.navigateByUrl(`/shop/product/${ product.ean }`)
  }

  resetSearch() {
    this.searchTerm = ''
    this.searchObserver.searchResetObserver.next()
  }

  performSearch() {
    this.searchTimeout = undefined;

    if (this.searchTerm) {
      this.productService.bySearchTerm(this.searchTerm, +this.page, this.bookLanguageObserver.currentLanguageStr).subscribe(
        (result) => {
          this.location.go(`/shop/search?q=${ this.searchTerm }&page=${ this.page }`);
          this.products = result
          this.productComponent.pagination = this.productService.pagination()
          this.productComponent.aggregations = this.productService.aggregations()
        }
      )
    }

    this.searchObserver.searchPerformedObserver.next(this.searchTerm)
  }

}
